import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { TCustomerType } from "redux/reducers/models/facility";
import { Badge } from "components/badge/Badge";
import { ButtonNew } from "components/buttonNew";

import BookingFeeCustomerTypeTags from "./BookingFeeCustomerTypeTags";

type TBookingFeeCustomerTypesSectionProps = {
  selectedTypes: TCustomerType[];
  onSelectCustomerTypes: () => void;
  onRemoveCustomerType?: (id: number) => void;
};

export default function BookingFeeCustomerTypesSection(props: TBookingFeeCustomerTypesSectionProps) {
  const { t } = useTranslation();
  const { selectedTypes, onSelectCustomerTypes, onRemoveCustomerType } = props;

  const [isViewingSelected, setIsViewingSelected] = useState(false);
  const selectedCount = selectedTypes.length;
  const hasSelection = selectedCount > 0;

  useEffect(() => {
    if (!hasSelection) {
      setIsViewingSelected(false);
    }
  }, [hasSelection]);

  function handleToggleViewSelected() {
    setIsViewingSelected(prev => !prev);
  }

  function handleEdit() {
    onSelectCustomerTypes();
  }

  return (
    <div className="booking-fees__section booking-fees__customer-types">
      <div className="booking-fees__section-label">{t("Customer types")}</div>
      <div className="booking-fees__section-support">
        {t("Select the customer types this booking fee applies to.")}
      </div>

      <div
        className={
          isViewingSelected && hasSelection
            ? "booking-fees__customer-types-panel booking-fees__customer-types-panel--expanded"
            : "booking-fees__customer-types-panel"
        }
      >
        <div className="booking-fees__customer-types-panel-header">
          <Badge
            type={hasSelection ? "success" : "gray"}
            size="medium"
            className={
              hasSelection
                ? "booking-fees__customer-types-badge"
                : "booking-fees__customer-types-badge booking-fees__customer-types-badge--empty"
            }
          >
            {selectedCount} {t("selected")}
          </Badge>

          <div className="booking-fees__customer-types-panel-actions">
            {!hasSelection ? (
              <ButtonNew
                size="small"
                type="secondary"
                className="booking-fees__customer-types-select-button"
                onClick={onSelectCustomerTypes}
              >
                {t("Select customer types")}
              </ButtonNew>
            ) : (
              <>
                <button
                  type="button"
                  className="booking-fees__customer-types-text-action"
                  onClick={handleToggleViewSelected}
                >
                  {isViewingSelected ? t("Hide selected") : t("View selected")}
                </button>
                <ButtonNew
                  size="small"
                  type="secondary"
                  className="booking-fees__customer-types-edit-button"
                  onClick={handleEdit}
                >
                  {t("Edit")}
                </ButtonNew>
              </>
            )}
          </div>
        </div>

        {isViewingSelected && hasSelection ? (
          <div className="booking-fees__customer-types-panel-body">
            <BookingFeeCustomerTypeTags types={selectedTypes} onRemove={onRemoveCustomerType} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
